import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-local",
  "use": "icon-local-usage",
  "viewBox": "0 0 62.36 65.25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 62.36 65.25\" id=\"icon-local\"><defs><style>#icon-local .cls-1{fill:'';}</style></defs><title>未标题-1</title><path class=\"cls-1\" d=\"M62.33,14.22H0V62.41a2.84,2.84,0,0,0,2.84,2.84H59.52a2.84,2.84,0,0,0,2.84-2.84V14.26S62.35,14.22,62.33,14.22ZM56.69,59.08h-51V16.56h51Z\" /><path class=\"cls-1\" d=\"M50,0H12.08L0,14.22H62.36ZM15.43,5.58H46.76l5.42,5.95H10.6Z\" /><rect class=\"cls-1\" x=\"11.42\" y=\"34.72\" width=\"39.53\" height=\"6.27\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/local.svg
// module id = txK9
// module chunks = 25